import { Product } from '../types';

// ============================================
// WIRE & CABLES
// ============================================
export const wireProducts: Product[] = [
  {
    id: "wire-1",
    name: "Gold Auto Cables (30 SWG)",
    slug: "gold-auto-cables-30swg",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "Premium quality auto cables available in various sizes: 14/0.3mm (1.00sq mm), 28/0.3mm (1.50sq mm), 35/0.3mm (2.50sq mm), 44/0.3mm (3.00sq mm), 65/0.3mm (4.00sq mm), 120/0.3mm (10sq mm).",
    featured: true,
    partNumber: "GAC-30SWG",
    image: "/products/wire-cables/gold-auto-cables-30swg.png",
    specifications: {
      "Wire Gauge": "30 SWG",
      "Material": "Copper with PVC insulation",
    },
    variantType: "size",
    defaultVariant: "gac-30swg-1.0",
    variants: [
      {
        id: "gac-30swg-1.0",
        code: "GAC-30SWG-1.0",
        name: "1.00 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "1.00 sq mm",
          "Stranding": "14/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
      {
        id: "gac-30swg-1.5",
        code: "GAC-30SWG-1.5",
        name: "1.50 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "1.50 sq mm",
          "Stranding": "28/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
      {
        id: "gac-30swg-2.5",
        code: "GAC-30SWG-2.5",
        name: "2.50 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "2.50 sq mm",
          "Stranding": "35/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
      {
        id: "gac-30swg-3.0",
        code: "GAC-30SWG-3.0",
        name: "3.00 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "3.00 sq mm",
          "Stranding": "44/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
      {
        id: "gac-30swg-4.0",
        code: "GAC-30SWG-4.0",
        name: "4.00 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "4.00 sq mm",
          "Stranding": "65/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
      {
        id: "gac-30swg-10.0",
        code: "GAC-30SWG-10.0",
        name: "10.00 sq mm",
        specifications: {
          "Wire Gauge": "30 SWG",
          "Size": "10.00 sq mm",
          "Stranding": "120/0.3mm",
          "Material": "Copper with PVC insulation",
        },
      },
    ],
    tags: ["wire", "cable", "auto", "gold", "premium"],
    applications: ["Automotive", "Vehicle Wiring"],
  },
  {
    id: "wire-2",
    name: "Gold Thin PVC (AVS Type)",
    slug: "gold-thin-pvc-avs",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "Thin wall PVC insulated cables. Available sizes: 16/0.2mm (0.50sq mm), 24/0.2mm (0.75sq mm), 32/0.2mm (1.00sq mm), 30/0.25mm (1.50sq mm), 35/0.3mm (2.50sq mm), 56/0.3mm (4.00sq mm), 84/0.3mm (6.00sq mm).",
    featured: true,
    image: "/products/wire-cables/gold-thin-pvc-avs.png",
    specifications: {
      "Type": "AVS (Automotive Very thin wall Single core)",
      "Available Sizes": "0.50, 0.75, 1.00, 1.50, 2.50, 4.00, 6.00 sq mm",
    },
  },
  {
    id: "wire-3",
    name: "Silver Wire (031 SWG)",
    slug: "silver-wire-031swg",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "High-quality silver-coated wires. Available in 4mm, 5mm, 6mm, 7mm, 8mm, and 10mm sizes.",
    image: "/products/wire-cables/silver-wire-031swg.png",
    specifications: {
      "Wire Gauge": "031 SWG",
      "Available Sizes": "4mm, 5mm, 6mm, 7mm, 8mm, 10mm",
    },
  },
  {
    id: "wire-4",
    name: "Export Thin Wire (036 SWG)",
    slug: "export-thin-036swg",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "Export quality thin wires. Available in 0.75mm, 1.00mm, and 1.50mm sizes.",
    image: "/products/wire-cables/export-thin-036swg.png",
    specifications: {
      "Wire Gauge": "036 SWG",
      "Available Sizes": "0.75mm, 1.00mm, 1.50mm",
      "Quality": "Export Grade",
    },
  },
  {
    id: "wire-5",
    name: "Premium Wire (034 SWG)",
    slug: "premium-wire-034swg",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "Premium quality wires available in 4mm, 5mm, 6mm, 7mm, 8mm, and 10mm sizes.",
    image: "/products/wire-cables/premium-wire-034swg.png",
    specifications: {
      "Wire Gauge": "034 SWG",
      "Available Sizes": "4mm, 5mm, 6mm, 7mm, 8mm, 10mm",
      "Quality": "Premium Grade",
    },
  },
  {
    id: "wire-6",
    name: "Premium Thin Wire (034 SWG)",
    slug: "premium-thin-034swg",
    category: "Wire & Cables",
    subcategory: "Auto Cables",
    description: "Premium thin wires. Available sizes: 0.50sq mm, 0.75sq mm, 1.00sq mm, 1.50sq mm, 2.50sq mm, 4.00sq mm, 6.00sq mm.",
    image: "/products/wire-cables/premium-thin-034swg.png",
    specifications: {
      "Wire Gauge": "034 SWG",
      "Available Sizes": "0.50, 0.75, 1.00, 1.50, 2.50, 4.00, 6.00 sq mm",
    },
  },
  {
    id: "wire-7",
    name: "Speaker Wire",
    slug: "speaker-wire",
    category: "Wire & Cables",
    subcategory: "Speaker Cables",
    description: "High-quality speaker wires available in Gold, Premium-2, and Premium-3 variants. Available in transparent (23/23 and 16/16) and white colors. Lengths: 25, 40, 50 & 91 meters.",
    partNumber: "SPW",
    image: "/products/wire-cables/speaker-wire.png",
    variantType: "color",
    defaultVariant: "spw-trans-2323",
    variants: [
      {
        id: "spw-trans-2323",
        code: "SPW-T-2323",
        name: "Transparent 23/23",
        specifications: {
          "Color": "Transparent",
          "Stranding": "23/23",
          "Quality": "Gold",
          "Available Lengths": "25m, 40m, 50m, 91m",
        },
      },
      {
        id: "spw-trans-1616",
        code: "SPW-T-1616",
        name: "Transparent 16/16",
        specifications: {
          "Color": "Transparent",
          "Stranding": "16/16",
          "Quality": "Gold",
          "Available Lengths": "25m, 40m, 50m, 91m",
        },
      },
      {
        id: "spw-white-2323",
        code: "SPW-W-2323",
        name: "White 23/23",
        specifications: {
          "Color": "White",
          "Stranding": "23/23",
          "Quality": "Premium-2",
          "Available Lengths": "25m, 40m, 50m, 91m",
        },
      },
      {
        id: "spw-white-1616",
        code: "SPW-W-1616",
        name: "White 16/16",
        specifications: {
          "Color": "White",
          "Stranding": "16/16",
          "Quality": "Premium-3",
          "Available Lengths": "25m, 40m, 50m, 91m",
        },
      },
    ],
    specifications: {
      "Type": "Speaker Wire",
      "Available Lengths": "25m, 40m, 50m, 91m",
    },
    tags: ["speaker", "wire", "audio", "cable"],
    applications: ["Audio Systems", "Car Audio", "Home Audio"],
  },


  // Battery Cables Set
  {
    id: "wire-battery-cable-fitting",
    name: "Battery Cable Fitting",
    slug: "battery-cable-fitting",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Battery cable fittings with one battery clamp terminal (positive or negative) and one ring terminal. Available in various lengths for flexible installation.",
    images: ["/products/wire-cables/battery-cable-set/battery-cable-fitting.jpg"],
    variantType: "size",
    defaultVariant: "bcf-12",
    variants: [
      {
        id: "bcf-12",
        code: "STC0012TL",
        name: "12\" (305mm)",
        specifications: {
          "Part Number": "STC0012TL",
          "Size": "12\"",
          "Length": "305mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bcf-18",
        code: "STC0018TL",
        name: "18\" (458mm)",
        specifications: {
          "Part Number": "STC0018TL",
          "Size": "18\"",
          "Length": "458mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bcf-24",
        code: "STC0024TL",
        name: "24\" (610mm)",
        specifications: {
          "Part Number": "STC0024TL",
          "Size": "24\"",
          "Length": "610mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bcf-30",
        code: "STC0030TL",
        name: "30\" (762mm)",
        specifications: {
          "Part Number": "STC0030TL",
          "Size": "30\"",
          "Length": "762mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bcf-36",
        code: "STC0036TL",
        name: "36\" (915mm)",
        specifications: {
          "Part Number": "STC0036TL",
          "Size": "36\"",
          "Length": "915mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bcf-42",
        code: "STC0042TL",
        name: "42\" (1067mm)",
        specifications: {
          "Part Number": "STC0042TL",
          "Size": "42\"",
          "Length": "1067mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
    ],
    specifications: {
      "Type": "Battery Cable Fitting",
      "Terminals": "Battery Clamp Terminal + Ring Terminal",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "fitting", "automotive"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "wire-battery-jointer-both-side",
    name: "Battery Jointer Both Side Terminal",
    slug: "battery-jointer-both-side-terminal",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Battery jointer cables with battery clamp terminals on both ends. Ideal for connecting multiple batteries or extending battery connections.",
    images: ["/products/wire-cables/battery-cable-set/battery-jointer-both-side-terminal.jpg"],
    variantType: "size",
    defaultVariant: "bjbs-12",
    variants: [
      {
        id: "bjbs-12",
        code: "SBC0012BT",
        name: "12\" (305mm)",
        specifications: {
          "Part Number": "SBC0012BT",
          "Size": "12\"",
          "Length": "305mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bjbs-18",
        code: "SBC0018BT",
        name: "18\" (458mm)",
        specifications: {
          "Part Number": "SBC0018BT",
          "Size": "18\"",
          "Length": "458mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bjbs-24",
        code: "SBC0024BT",
        name: "24\" (610mm)",
        specifications: {
          "Part Number": "SBC0024BT",
          "Size": "24\"",
          "Length": "610mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bjbs-30",
        code: "SBC0030BT",
        name: "30\" (762mm)",
        specifications: {
          "Part Number": "SBC0030BT",
          "Size": "30\"",
          "Length": "762mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bjbs-36",
        code: "SBC0036BT",
        name: "36\" (915mm)",
        specifications: {
          "Part Number": "SBC0036BT",
          "Size": "36\"",
          "Length": "915mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "bjbs-42",
        code: "SBC0042BT",
        name: "42\" (1067mm)",
        specifications: {
          "Part Number": "SBC0042BT",
          "Size": "42\"",
          "Length": "1067mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
    ],
    specifications: {
      "Type": "Battery Jointer Both Side Terminal",
      "Terminals": "Battery Clamp Terminal on Both Ends",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "jointer", "automotive"],
    applications: ["Automotive", "Battery Connections", "Battery Extension"],
  },
  {
    id: "wire-battery-terminal-jointer",
    name: "Battery Terminal Jointer",
    slug: "battery-terminal-jointer",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Heavy-duty battery terminal jointer cables with ring terminals on both ends. Robust construction for reliable battery connections.",
    images: ["/products/wire-cables/battery-cable-set/battery-terminal-jointer.jpg"],
    variantType: "size",
    defaultVariant: "btj-12",
    variants: [
      {
        id: "btj-12",
        code: "SBC0012DL",
        name: "12\" (305mm)",
        specifications: {
          "Part Number": "SBC0012DL",
          "Size": "12\"",
          "Length": "305mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "btj-18",
        code: "SBC0018DL",
        name: "18\" (458mm)",
        specifications: {
          "Part Number": "SBC0018DL",
          "Size": "18\"",
          "Length": "458mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "btj-24",
        code: "SBC0024DL",
        name: "24\" (610mm)",
        specifications: {
          "Part Number": "SBC0024DL",
          "Size": "24\"",
          "Length": "610mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "btj-30",
        code: "SBC0030DL",
        name: "30\" (762mm)",
        specifications: {
          "Part Number": "SBC0030DL",
          "Size": "30\"",
          "Length": "762mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "btj-36",
        code: "SBC0036DL",
        name: "36\" (915mm)",
        specifications: {
          "Part Number": "SBC0036DL",
          "Size": "36\"",
          "Length": "915mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
      {
        id: "btj-42",
        code: "SBC0042DL",
        name: "42\" (1067mm)",
        specifications: {
          "Part Number": "SBC0042DL",
          "Size": "42\"",
          "Length": "1067mm",
          "Standard Packing": "10 Pcs. Packing",
        },
      },
    ],
    specifications: {
      "Type": "Battery Terminal Jointer",
      "Terminals": "Ring Terminal on Both Ends",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "jointer", "ring terminal", "automotive"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty"],
  },
  {
    id: "wire-jumper-cable-set",
    name: "Jumper Cable Set",
    slug: "jumper-cable-set",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Heavy-duty jumper cable sets with crocodile clips on both ends. Red and black cables with insulated handles for safe battery jump-starting.",
    images: ["/products/wire-cables/battery-cable-set/jumper-cable-set.jpg"],
    variantType: "size",
    defaultVariant: "jcs-1.8",
    variants: [
      {
        id: "jcs-1.8",
        code: "SBC000031",
        name: "1.8 Meter",
        specifications: {
          "Part Number": "SBC000031",
          "Length": "1.8 Meter",
          "Length (mm)": "1800mm",
          "Standard Packing": "1 Set Packing",
        },
      },
      {
        id: "jcs-2.5",
        code: "SBC000034",
        name: "2.5 Meter",
        specifications: {
          "Part Number": "SBC000034",
          "Length": "2.5 Meter",
          "Length (mm)": "2500mm",
          "Standard Packing": "1 Set Packing",
        },
      },
      {
        id: "jcs-3.0",
        code: "SBC000036",
        name: "3 Meter",
        specifications: {
          "Part Number": "SBC000036",
          "Length": "3 Meter",
          "Length (mm)": "3000mm",
          "Standard Packing": "1 Set Packing",
        },
      },
      {
        id: "jcs-4.0",
        code: "SBC000038",
        name: "4 Meter",
        specifications: {
          "Part Number": "SBC000038",
          "Length": "4 Meter",
          "Length (mm)": "4000mm",
          "Standard Packing": "1 Set Packing",
        },
      },
      {
        id: "jcs-6.0",
        code: "SBC000042",
        name: "6 Meter",
        specifications: {
          "Part Number": "SBC000042",
          "Length": "6 Meter",
          "Length (mm)": "6000mm",
          "Standard Packing": "1 Set Packing",
        },
      },
    ],
    specifications: {
      "Type": "Jumper Cable Set",
      "Terminals": "Crocodile Clips with Insulated Handles",
      "Standard Packing": "1 Set Packing",
    },
    tags: ["jumper", "cable", "battery", "jump-start", "automotive"],
    applications: ["Automotive", "Battery Jump-Starting", "Emergency"],
  },
  {
    id: "wire-flat-earthing-wire",
    name: "Flat Earthing Wire",
    slug: "flat-earthing-wire",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Braided flat earthing wires for grounding applications. Available in various lengths for different installation requirements.",
    images: ["/products/wire-cables/battery-cable-set/flat-earthing-wire.jpg"],
    variantType: "size",
    defaultVariant: "few-roll",
    variants: [
      {
        id: "few-roll",
        code: "SEW000001",
        name: "Roll (7.5 Meter)",
        specifications: {
          "Part Number": "SEW000001",
          "Size": "Roll",
          "Length": "7.5 Meter",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-12",
        code: "SEW000012",
        name: "12\" (305mm)",
        specifications: {
          "Part Number": "SEW000012",
          "Size": "12\"",
          "Length": "305mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-15",
        code: "SEW000015",
        name: "15\" (381mm)",
        specifications: {
          "Part Number": "SEW000015",
          "Size": "15\"",
          "Length": "381mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-18",
        code: "SEW000018",
        name: "18\" (458mm)",
        specifications: {
          "Part Number": "SEW000018",
          "Size": "18\"",
          "Length": "458mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
      {
        id: "few-24",
        code: "SEW000024",
        name: "24\" (610mm)",
        specifications: {
          "Part Number": "SEW000024",
          "Size": "24\"",
          "Length": "610mm",
          "Standard Packing": "12 Pcs. Packing",
        },
      },
    ],
    specifications: {
      "Type": "Flat Earthing Wire",
      "Material": "Braided Metallic Strip",
      "Standard Packing": "12 Pcs. Packing",
    },
    tags: ["earthing", "wire", "grounding", "flat", "braided"],
    applications: ["Automotive", "Grounding", "Electrical Safety"],
  },
  {
    id: "wire-battery-cable-set-maruti-car",
    name: "Maruti Car Cable Set (Negative & Positive)",
    slug: "maruti-car-cable-set",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Complete cable set for Maruti cars, including both negative and positive battery cables with terminal clamps and ring terminals for reliable power connections.",
    partNumber: "SBC000021",
    images: ["/products/wire-cables/battery-cable-set/SBC000021.jpg"],
    specifications: {
      "Type": "Maruti Car Cable Set",
      "Contents": "Negative & Positive Cables",
      "Terminals": "Battery Clamp Terminal + Ring Terminal",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "maruti", "car", "automotive"],
    applications: ["Automotive", "Battery Connections", "Maruti Car"],
  },
  {
    id: "wire-battery-cable-set-maruti-van",
    name: "Maruti Van Cable Set (Negative & Positive)",
    slug: "maruti-van-cable-set",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Complete cable set for Maruti vans, including both negative and positive battery cables with terminal clamps and ring terminals for reliable power connections.",
    partNumber: "SBC000026",
    images: ["/products/wire-cables/battery-cable-set/SBC000026.jpg"],
    specifications: {
      "Type": "Maruti Van Cable Set",
      "Contents": "Negative & Positive Cables",
      "Terminals": "Battery Clamp Terminal + Ring Terminal",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "maruti", "van", "automotive"],
    applications: ["Automotive", "Battery Connections", "Maruti Van"],
  },
  {
    id: "wire-battery-cable-set-north-america-1",
    name: "Battery Cable Set for (North America) Positive (+) on the Right",
    slug: "battery-cable-set-north-america-1",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Battery cable set for North America with positive (+) terminal on the right. Top-post style battery terminals for standard automotive applications.",
    partNumber: "SBC000032",
    images: ["/products/wire-cables/battery-cable-set/SBC000032.jpg"],
    specifications: {
      "Type": "Battery Cable Set",
      "Region": "North America",
      "Terminal Position": "Positive (+) on the Right",
      "Terminal Type": "Top-Post",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "north america", "automotive"],
    applications: ["Automotive", "Battery Connections", "North America"],
  },
  {
    id: "wire-battery-cable-set-north-america-2",
    name: "Battery Cable Set for (North America) Positive (+) on the Right",
    slug: "battery-cable-set-north-america-2",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Battery cable set for North America with positive (+) terminal on the right. Includes red positive and black negative cables with top-post terminals and auxiliary wires.",
    partNumber: "SBC000036",
    images: ["/products/wire-cables/battery-cable-set/SBC000036.jpg"],
    specifications: {
      "Type": "Battery Cable Set",
      "Region": "North America",
      "Terminal Position": "Positive (+) on the Right",
      "Terminal Type": "Top-Post with Auxiliary Wires",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "north america", "automotive", "auxiliary"],
    applications: ["Automotive", "Battery Connections", "North America"],
  },
  {
    id: "wire-battery-cable-set-earth-moving",
    name: "Battery Cable Set for Earth Moving Vehicle",
    slug: "battery-cable-set-earth-moving-vehicle",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Heavy-duty battery cable set for earth moving vehicles. Robust clamp-style terminals with thick red and black cables for demanding applications.",
    partNumber: "SBC000042",
    images: ["/products/wire-cables/battery-cable-set/SBC000042.jpg"],
    specifications: {
      "Type": "Battery Cable Set",
      "Application": "Earth Moving Vehicle",
      "Terminal Type": "Heavy-Duty Clamp Style",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "earth moving", "heavy duty", "automotive"],
    applications: ["Automotive", "Battery Connections", "Earth Moving Vehicles", "Heavy Duty"],
  },
  {
    id: "wire-battery-cable-set-seva-type",
    name: "Battery Cable Set for Seva Type",
    slug: "battery-cable-set-seva-type",
    category: "Wire & Cables",
    subcategory: "Battery Cables",
    description: "Battery cable set for Seva type vehicles. Standard clamp-style battery terminals with red and black cables for reliable connections.",
    partNumber: "SBC000046",
    images: ["/products/wire-cables/battery-cable-set/SBC000046.jpg"],
    specifications: {
      "Type": "Battery Cable Set",
      "Application": "Seva Type",
      "Terminal Type": "Clamp Style",
      "Standard Packing": "10 Pcs. Packing",
    },
    tags: ["battery", "cable", "seva", "automotive"],
    applications: ["Automotive", "Battery Connections", "Seva Vehicles"],
  },
];
